const PAGE_AND_ROUTES = [
  {
    subDomain: "all",
    paths: [
      { path: "/", pathType: "Prefix", service: "c360-production-service", contentType: "Home Pages" },
      {
        path: "/ajax/no-cache/:path1",
        pathType: "Prefix",
        service: "c360-production-service",
      },
      {
        path: "/exams",
        pathType: "Exact",
        service: "cnext-frontend-article-production-service",
        contentType: "Exam Listing",
      },
      {
        path: "/college-predictor",
        pathType: "Prefix",
        service: "c360-production-service",
        contentType: "college-predictor"
      },
      {
        path: "/education-ajax-product-mapping-ajax",
        pathType: "Prefix",
        service: "c360-production-service",
      },
      {
        path: "/exams/:path1/all-questions",
        pathType: "ImplementationSpecific",
        service: "c360-production-service",
        contentType: "Exams",
      },
      {
        path: "/adbuddy",
        pathType: "ImplementationSpecific",
        service: "c360-production-service",
      },
      {
        path: "/adbuddy-engine-application-forms/:path1",
        pathType: "ImplementationSpecific",
        service: "c360-production-service",
      },
      {
        path: "/admissionbuddy",
        pathType: "ImplementationSpecific",
        service: "c360-production-service",
      },
      { path: "/user", pathType: "Prefix", service: "c360-production-service" },
      {
        path: "/ajax",
        pathType: "ImplementationSpecific",
        service: "c360-production-service",
      },
      {
        path: "/inventories",
        pathType: "Prefix",
        service: "c360-production-service",
      },
      {
        path: "/middleware-csrf-token",
        pathType: "Prefix",
        service: "c360-production-service",
      },
      {
        path: "/colleges/reviews/:path1",
        pathType: "Prefix",
        service: "cnext-frontend-production-service",
      },
      {
        path: "/premium",
        pathType: "Prefix",
        service: "cnext-frontend-premium-production-service",
      },
      {
        path: "/contact-us",
        pathType: "ImplementationSpecific",
        service: "cnext-frontend-common-production-service",
      },
      {
        path: "/privacy-policy",
        pathType: "ImplementationSpecific",
        service: "cnext-frontend-common-production-service",
      },
      {
        path: "/exams/cuet-pg",
        pathType: "ImplementationSpecific",
        service: "c360-production-service",
      },
      {
        path: "/idp",
        pathType: "Prefix",
        service: "cnext-frontend-idp-production-service",
      },
      {
        path: "/idp/virtual-fair-user-preference",
        pathType: "Prefix",
        service: "cnext-frontend-idp-production-service",
      },
      {
        path: "/dashboard",
        pathType: "Prefix",
        service: "cnext-frontend-dashboard-production-service",
      },
      {
        path: "/cms",
        pathType: "Prefix",
        service: "cnext-frontend-cms-production-service",
      },
      {
        path: "/courses-certifications/:path1",
        pathType: "Prefix",
        service: "c360-production-service",
        contentType: "Certification"
      },
      {
        path: "/courses-certifications/articles/:path1",
        pathType: "Prefix",
        service: "cnext-frontend-article-production-service",
      },
      {
        path: "/articles/universities-in-australia-with-no-application-fee",
        pathType: "ImplementationSpecific",
        service: "cnext-frontend-article-production-service",
      },
      {
        path: "/articles/universities-in-:path1",
        pathType: "ImplementationSpecific",
        service: "cnext-frontend-article-production-service",
      },
      {
        path: "/articles/:path1",
        pathType: "ImplementationSpecific",
        service: "cnext-frontend-article-production-service",
        contentType: "Article"
      },
      {
        path: "/courses",
        pathType: "Prefix",
        service: "cnext-frontend-article-production-service",
      },
      {
        path: "/courses-certifications/articles/15-courses-on-time-management-to-make-the-most-of-your-time-certp",
        pathType: "Prefix",
        service: "cnext-frontend-article-production-service",
      },
      {
        path: "/careers/articles",
        pathType: "Prefix",
        service: "cnext-frontend-article-production-service",
      },
      {
        path: "/:path1full/:path2form",
        pathType: "ImplementationSpecific",
        service: "cnext-frontend-article-production-service",
      },
      {
        path: "/how",
        pathType: "Prefix",
        service: "cnext-frontend-article-production-service",
      },
      {
        path: "/:path1/universities/:path2-unpg",
        pathType: "ImplementationSpecific",
        service: "cnext-frontend-study-abroad-production-service",
      },
      {
        path: "/:path1/universities/:path2",
        pathType: "ImplementationSpecific",
        service: "cnext-frontend-article-production-service",
      },
      {
        path: "/:path1/universities:path2",
        pathType: "ImplementationSpecific",
        service: "cnext-frontend-study-abroad-production-service",
      },
      {
        path: "/:path1/universities/:path2/:path3-coursepg",
        pathType: "ImplementationSpecific",
        service: "cnext-frontend-study-abroad-production-service",
      },
      {
        path: "/coaching",
        pathType: "ImplementationSpecific",
        service: "cnext-frontend-coaching-production-service",
      },
      {
        path: "/exams/:path1/:path2",
        pathType: "ImplementationSpecific",
        service: "cnext-frontend-article-production-service",
        contentType: "Exam Detail"
      },
      {
        path: "/study-in-:path1-cnhp",
        pathType: "ImplementationSpecific",
        service: "cnext-frontend-study-abroad-production-service",
      },
      {
        path: "/all-articles",
        pathType: "ImplementationSpecific",
        service: "cnext-frontend-article-production-service",
      },
      {
        path: "/articles",
        pathType: "ImplementationSpecific",
        service: "cnext-frontend-article-production-service",
      },
      {
        path: "/courses-certifications/articles",
        pathType: "ImplementationSpecific",
        service: "cnext-frontend-article-production-service",
      },
      {
        path: "/courses-certifications/articles/expert-reviews",
        pathType: "ImplementationSpecific",
        service: "cnext-frontend-article-production-service",
      },
      {
        path: "/hi/articles",
        pathType: "Prefix",
        service: "cnext-frontend-article-production-service",
      },
      {
        path: "/:path/articles",
        pathType: "Prefix",
        service: "cnext-frontend-article-production-service",
      },
    ],
  },
  {
    subDomain: "www",
    paths: [
      {
        path: "/",
        pathType: "Exact",
        service: "cnext-frontend-common-production-service",
        contentType: "Home Pages"
      },
      {
        path: "/grievance-redressal",
        pathType: "Prefix",
        service: "cnext-frontend-common-production-service",
      },
      { path: "/blog", pathType: "Prefix", service: "wordpress-production" },
      {
        path: "/ajax/no-cache/:path1",
        pathType: "Prefix",
        service: "c360-production-service",
      },
      {
        path: "/exams$",
        pathType: "Exact",
        service: "cnext-frontend-article-production-service",
      },
      {
        path: "/college-predictor",
        pathType: "Prefix",
        service: "c360-production-service",
        contentType: "college-predictor",
      },
      {
        path: "/education-ajax-product-mapping-ajax",
        pathType: "Prefix",
        service: "c360-production-service",
      },
      {
        path: "/exams/:path1/all-questions",
        pathType: "ImplementationSpecific",
        service: "c360-production-service",
      },
      {
        path: "/adbuddy",
        pathType: "ImplementationSpecific",
        service: "c360-production-service",
      },
      {
        path: "/adbuddy-engine-application-forms/:path1",
        pathType: "ImplementationSpecific",
        service: "c360-production-service",
      },
      {
        path: "/admissionbuddy",
        pathType: "ImplementationSpecific",
        service: "c360-production-service",
      },
      { path: "/user", pathType: "Prefix", service: "c360-production-service" },
      {
        path: "/ajax",
        pathType: "ImplementationSpecific",
        service: "c360-production-service",
      },
      {
        path: "/inventories",
        pathType: "Prefix",
        service: "c360-production-service",
      },
      {
        path: "/middleware-csrf-token",
        pathType: "Prefix",
        service: "c360-production-service",
      },
      {
        path: "/colleges/reviews/:path1",
        pathType: "Prefix",
        service: "cnext-frontend-production-service",
      },
      {
        path: "/premium",
        pathType: "Prefix",
        service: "cnext-frontend-premium-production-service",
      },
      {
        path: "/contact-us",
        pathType: "ImplementationSpecific",
        service: "cnext-frontend-common-production-service",
      },
      {
        path: "/privacy-policy",
        pathType: "ImplementationSpecific",
        service: "cnext-frontend-common-production-service",
      },
      {
        path: "/university/:path1",
        pathType: "ImplementationSpecific",
        service: "cnext-frontend-production-service",
        contentType: "College Detail",
      },
      {
        path: "/university/:path1/:path2",
        pathType: "ImplementationSpecific",
        service: "cnext-frontend-production-service",
        contentType: "College Detail",
      },
      {
        path: "/colleges/:path1",
        pathType: "ImplementationSpecific",
        service: "cnext-frontend-production-service",
        contentType: "College Detail",
      },
      {
        path: "/colleges/:path1/:path2",
        pathType: "ImplementationSpecific",
        service: "cnext-frontend-production-service",
        contentType: "College Detail",
      },
      {
        path: "/all-articles",
        pathType: "ImplementationSpecific",
        service: "cnext-frontend-article-production-service",
        contentType: "Article Landing"
      },
      {
        path: "/exams/cuet-pg",
        pathType: "ImplementationSpecific",
        service: "c360-production-service",
      },
    //   {
    //     path: "/:path1",
    //     pathType: "ImplementationSpecific",
    //     service: "cnext-frontend-study-abroad-production-service",
    //   },
      {
        path: "/colleges/:path1",
        pathType: "ImplementationSpecific",
        service: "cnext-frontend-production-service",
      },
      {
        path: "/idp",
        pathType: "Prefix",
        service: "cnext-frontend-idp-production-service",
      },
      {
        path: "/idp/virtual-fair-user-preference",
        pathType: "Prefix",
        service: "cnext-frontend-idp-production-service",
      },
      {
        path: "/dashboard",
        pathType: "Prefix",
        service: "cnext-frontend-dashboard-production-service",
      },
      {
        path: "/cms",
        pathType: "Prefix",
        service: "cnext-frontend-cms-production-service",
      },
      {
        path: "/courses-certifications/:path1",
        pathType: "Prefix",
        service: "c360-production-service",
      },
      {
        path: "/courses-certifications/articles/:path1",
        pathType: "Prefix",
        service: "cnext-frontend-article-production-service",
      },
      {
        path: "/articles/:path1",
        pathType: "Prefix",
        service: "cnext-frontend-article-production-service",
      },
      {
        path: "/courses",
        pathType: "Prefix",
        service: "cnext-frontend-article-production-service",
      },
      {
        path: "/courses-certifications/articles/15-courses-on-time-management-to-make-the-most-of-your-time-certp",
        pathType: "Prefix",
        service: "cnext-frontend-article-production-service",
      },
      {
        path: "/careers/articles",
        pathType: "Prefix",
        service: "cnext-frontend-article-production-service",
      },
      {
        path: "/:path1full/:path2form",
        pathType: "ImplementationSpecific",
        service: "cnext-frontend-article-production-service",
      },
      {
        path: "/how",
        pathType: "Prefix",
        service: "cnext-frontend-article-production-service",
      },
      {
        path: "/:path1/universities/:path2-unpg",
        pathType: "ImplementationSpecific",
        service: "cnext-frontend-study-abroad-production-service",
      },
      {
        path: "/:path1/universities/:path2",
        pathType: "ImplementationSpecific",
        service: "cnext-frontend-article-production-service",
      },
      {
        path: "/api/ad-buddy/:path1",
        pathType: "ImplementationSpecific",
        service: "c360-production-service",
      },
      {
        path: "/:path1/universities/:path2",
        pathType: "ImplementationSpecific",
        service: "cnext-frontend-study-abroad-production-service",
        contentType: "StudyAbroad Detail"
      },
      {
        path: "/:path1/universities/:path2/:path3-coursepg",
        pathType: "ImplementationSpecific",
        service: "cnext-frontend-study-abroad-production-service",
        service: "cnext-frontend-study-abroad-production-service",
        contentType: "StudyAbroad Detail"
      },
      {
        path: "/coaching",
        pathType: "ImplementationSpecific",
        service: "cnext-frontend-coaching-production-service",
      },
      {
        path: "/exams/:path1/:path2",
        pathType: "ImplementationSpecific",
        service: "cnext-frontend-article-production-service",
      },
      {
        path: "/study-in-:path1-cnhp",
        pathType: "ImplementationSpecific",
        service: "cnext-frontend-study-abroad-production-service",
      },
      {
        path: "/all-articles",
        pathType: "ImplementationSpecific",
        service: "cnext-frontend-article-production-service",
      },
      {
        path: "/articles",
        pathType: "ImplementationSpecific",
        service: "cnext-frontend-article-production-service",
      },
      {
        path: "/courses-certifications/articles",
        pathType: "ImplementationSpecific",
        service: "cnext-frontend-article-production-service",
      },
      {
        path: "/courses-certifications/articles/expert-reviews",
        pathType: "ImplementationSpecific",
        service: "cnext-frontend-article-production-service",
      },
      {
        path: "/hi/articles",
        pathType: "Prefix",
        service: "cnext-frontend-article-production-service",
      },
      {
        path: "/magazine",
        pathType: "Prefix",
        service: "cnext-frontend-common-production-service",
      },
      {
        path: "/magazine/:path",
        pathType: "Prefix",
        service: "cnext-frontend-common-production-service",
      },
      {
        path: "/webinars",
        pathType: "ImplementationSpecific",
        service: "cnext-frontend-common-production-service",
      },
      {
        path: "/webinars/:path",
        pathType: "ImplementationSpecific",
        service: "cnext-frontend-common-production-service",
      },
    //   {
    //     path: "/:path1-pge",
    //     pathType: "ImplementationSpecific",
    //     service: "cnext-frontend-article-production-service",
    //   },
      {
        path: "/hiring",
        pathType: "Prefix",
        service: "cnext-frontend-common-production-service",
      },
      {
        path: "/hiring/:path",
        pathType: "Prefix",
        service: "cnext-frontend-common-production-service",
      },
      {
        path: "/english/:path",
        pathType: "Prefix",
        service: "cnext-frontend-article-production-service",
      },
    ],
  },
  {
    subDomain: "school",
    paths: [
      {
        path: "/",
        pathType: "Prefix",
        service: "cnext-frontend-school-production-service",
        contentType: "Home Pages"
      },
      {
        path: "/ajax/no-cache/:path1",
        pathType: "Prefix",
        service: "c360-production-service",
      },
      {
        path: "/education-ajax-product-mapping-ajax",
        pathType: "Prefix",
        service: "c360-production-service",
      },
      { path: "/user", pathType: "Prefix", service: "c360-production-service" },
      {
        path: "/sitemap",
        pathType: "Prefix",
        service: "c360-production-service",
      },
      {
        path: "/ebook/ajax",
        pathType: "Prefix",
        service: "c360-production-service",
      },
      {
        path: "/api/ad-buddy/:path1",
        pathType: "Prefix",
        service: "c360-production-service",
      },
      {
        path: "/inventories/:path1",
        pathType: "Prefix",
        service: "c360-production-service",
      },
      {
        path: "/middleware-csrf-token",
        pathType: "Prefix",
        service: "c360-production-service",
      },
      {
        path: "/exams/:path1/all-questions",
        pathType: "ImplementationSpecific",
        service: "c360-production-service",
      },
      {
        path: "/download",
        pathType: "Prefix",
        service: "c360-production-service",
      },
      {
        path: "/idp",
        pathType: "Prefix",
        service: "cnext-frontend-idp-production-service",
      },
      {
        path: "/dashboard",
        pathType: "Prefix",
        service: "cnext-frontend-dashboard-production-service",
      },
      {
        path: "/articles",
        pathType: "Prefix",
        service: "cnext-frontend-article-production-service",
      },
      {
        path: "/hi",
        pathType: "Prefix",
        service: "cnext-frontend-article-production-service",
      },
      {
        path: "/courses/",
        pathType: "Prefix",
        service: "cnext-frontend-article-production-service",
      },
      {
        path: "/:path1spch.:path2",
        pathType: "Prefix",
        service: "cnext-frontend-article-production-service",
      },
      {
        path: "/chemistry",
        pathType: "Prefix",
        service: "cnext-frontend-article-production-service",
      },
      {
        path: "/ncert",
        pathType: "Prefix",
        service: "cnext-frontend-article-production-service",
      },
      {
        path: "/maths",
        pathType: "Prefix",
        service: "cnext-frontend-article-production-service",
      },
      {
        path: "/biology",
        pathType: "Prefix",
        service: "cnext-frontend-article-production-service",
      },
      {
        path: "/physics",
        pathType: "Prefix",
        service: "cnext-frontend-article-production-service",
      },
      {
        path: "/english",
        pathType: "Prefix",
        service: "cnext-frontend-article-production-service",
      },
      {
        path: "/courses/articles/",
        pathType: "Prefix",
        service: "cnext-frontend-article-production-service",
      },
      {
        path: "/boards",
        pathType: "Prefix",
        service: "cnext-frontend-article-production-service",
      },
      {
        path: "/cbse",
        pathType: "Prefix",
        service: "cnext-frontend-article-production-service",
      },
      {
        path: "/:path1essy",
        pathType: "Prefix",
        service: "cnext-frontend-article-production-service",
      },
      {
        path: "/:path1spch",
        pathType: "Prefix",
        service: "cnext-frontend-article-production-service",
      },
      {
        path: "/:path1words",
        pathType: "Prefix",
        service: "cnext-frontend-article-production-service",
      },
      {
        path: "/:path1tab",
        pathType: "Prefix",
        service: "cnext-frontend-article-production-service",
      },
      {
        path: "/physics",
        pathType: "Prefix",
        service: "cnext-frontend-article-production-service",
      },
      {
        path: "/how",
        pathType: "Prefix",
        service: "cnext-frontend-article-production-service",
      },
      {
        path: "/rd-sharma-solutions",
        pathType: "Prefix",
        service: "cnext-frontend-article-production-service",
      },
      {
        path: "/schools/:path",
        pathType: "Prefix",
        service: "cnext-frontend-school-production-service",
      },
      {
        path: "/careers/articles",
        pathType: "Prefix",
        service: "cnext-frontend-article-production-service",
      },
      {
        path: "/admissionbuddy",
        pathType: "ImplementationSpecific",
        service: "c360-production-service",
      },
      {
        path: "/exams$",
        pathType: "Exact",
        service: "cnext-frontend-article-production-service",
      },
      {
        path: "/exams/:path1/:path2",
        pathType: "ImplementationSpecific",
        service: "cnext-frontend-article-production-service",
      },
    ],
  },
  {
    subDomain: "news",
    paths: [
      {
        path: "/",
        pathType: "ImplementationSpecific",
        service: "cnext-frontend-news-production-service",
        contentType: "Google News"
      },
      {
        path: "/:path1",
        pathType: "ImplementationSpecific",
        service: "cnext-frontend-news-production-service",
        contentType: "Google News"
      },
      {
        path: "/education-ajax-product-mapping-ajax",
        pathType: "Prefix",
        service: "c360-production-service",
        contentType: "Google News"
      },
      {
        path: "/ajax/no-cache/:path1",
        pathType: "Prefix",
        service: "c360-production-service",
        contentType: "Google News"
      },
      {
        path: "/dj-api",
        pathType: "ImplementationSpecific",
        service: "c360-production-service",
        contentType: "Google News"
      },
      {
        path: "/ajax",
        pathType: "ImplementationSpecific",
        service: "c360-production-service",
      },
      {
        path: "/user",
        pathType: "ImplementationSpecific",
        service: "c360-production-service",
      },
      {
        path: "/gate-admit-card-2024",
        pathType: "ImplementationSpecific",
        service: "c360-production-service",
      },
      {
        path: "/middleware-csrf-token",
        pathType: "ImplementationSpecific",
        service: "c360-production-service",
      },
      {
        path: "/idp",
        pathType: "ImplementationSpecific",
        service: "cnext-frontend-idp-production-service",
      },
      {
        path: "/dashboard",
        pathType: "ImplementationSpecific",
        service: "cnext-frontend-dashboard-production-service",
      },
      {
        path: "/inventories",
        pathType: "ImplementationSpecific",
        service: "c360-production-service",
      },
      {
        path: "/admissionbuddy",
        pathType: "ImplementationSpecific",
        service: "c360-production-service",
      },
      {
        path: "/adbuddy",
        pathType: "ImplementationSpecific",
        service: "c360-production-service",
      },
      {
        path: "/adbuddy-engine-application-forms/:path1",
        pathType: "ImplementationSpecific",
        service: "c360-production-service",
      },
      {
        path: "/api/ad-buddy/:path1",
        pathType: "Prefix",
        service: "c360-production-service",
      },
    ],
  },
  {
    subDomain: "hindinews",
    paths: [
      {
        path: "/",
        pathType: "ImplementationSpecific",
        service: "cnext-frontend-news-production-service",
        contentType: "Google News"
      },
      {
        path: "/ajax/no-cache/:path1",
        pathType: "Prefix",
        service: "c360-production-service",
        contentType: "Google News"
      },
      {
        path: "/dj-api",
        pathType: "ImplementationSpecific",
        service: "c360-production-service",
        contentType: "Google News"
      },
      {
        path: "/ajax",
        pathType: "ImplementationSpecific",
        service: "c360-production-service",
      },
      {
        path: "/user",
        pathType: "ImplementationSpecific",
        service: "c360-production-service",
      },
      {
        path: "/api/ad-buddy/:path1",
        pathType: "ImplementationSpecific",
        service: "c360-production-service",
      },
      {
        path: "/middleware-csrf-token",
        pathType: "ImplementationSpecific",
        service: "c360-production-service",
      },
      {
        path: "/idp",
        pathType: "ImplementationSpecific",
        service: "c360-production-service",
      },
      {
        path: "/dashboard",
        pathType: "ImplementationSpecific",
        service: "cnext-frontend-dashboard-production-service",
      },
      {
        path: "/inventories",
        pathType: "ImplementationSpecific",
        service: "c360-production-service",
      },
      {
        path: "/admissionbuddy",
        pathType: "ImplementationSpecific",
        service: "c360-production-service",
      },
      {
        path: "/adbuddy",
        pathType: "ImplementationSpecific",
        service: "c360-production-service",
      },
      {
        path: "/adbuddy-engine-application-forms/:path1",
        pathType: "ImplementationSpecific",
        service: "c360-production-service",
      },
    ],
  },
  {
    subDomain: "study-abroad",
    paths: [
      {
        path: "/:path1",
        pathType: "ImplementationSpecific",
        service: "cnext-frontend-study-abroad-production-service",
        contentType: "Studyabroad"
      },
    ],
  },
];

export default PAGE_AND_ROUTES